import { useCallback } from 'react';
import styles from './index.module.sass';
import icon from 'images/ride_with_autopass.svg';
import { CUSTOMER_SERVICE_MAIL } from 'config';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

const Wrapper = ({ bgTheme, children }) => {
  const wrapperClass = cx({
    wrapper: true,
    [bgTheme]: true,
  });

  const WiggleBalls = useCallback(() => {
    return (
      <div className={styles.wiggle}>
        <div className={styles.ball1} />
        <div className={styles.ball2} />
        <div className={styles.ball3} />
      </div>
    );
  }, []);

  return (
    <div className={wrapperClass}>
      <WiggleBalls />
      <div>{children}</div>
      <footer>
        <ul className={styles.contact}>
          <li>
            <a href={`mailto:${CUSTOMER_SERVICE_MAIL}?subject=［客服］Autopass 快速通`}>來信客服</a>
          </li>
          <li>
            <a href={`mailto:charge@autopass.xyz?subject=［合作］Autopass 快速通`}>與我們合作</a>
          </li>
        </ul>
        <div>
          <img src={icon} alt="pick-n-charge-icon" />
        </div>
      </footer>
    </div>
  );
};

export default Wrapper;
